// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  LMDB: 'ERIS',
  api: {
     //prod 
 
   /*generateExcel:`https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/GenerateExcel`,
   //generatePdf: `https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/GeneratePDF`,
   generatePdf: `https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/v2_ConvertToPdf`,
   pdfToWord: `https://erisservice8.erisinfo.com/ErisExt/reppdftoword-prod/PDFtoWord`,
   generateCloserXML:`https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/GenerateCloserXML`,
   htmlToPdf: `https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/HtmlToPdf`,
   universalCall: `https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/CallOra`,
   ssoLogin: `https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/SSOLogin`,
   uploadFile2:`https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/V2_UploadFile`,
   mergePdf2: `https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RWPDFSrv.svc/MergePDF_v2`,
   saveHFURL:`https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/SaveHeaderFooterData`,
   toExcelURL:`https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/GenerateTableExcel`,
   getHFSample:`https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/GetFooterHeaderTemplates`,
   addStamp:`https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RWPDFSrv.svc/AddStamp`,
   rotateImage: `https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/RotateImage`,
   generateXML: `https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/GenerateXML`,
   generateJson: `https://erisservice9.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/GenerateJson`,
   generatePortfolioZip: `https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/GeneratePortfolioZip`,
   pcaschema:`file:///C:/Users/e4ujys/Fannie%20Mae/OneDrive%20-%20Fannie%20Mae/3rd%20Party%20Reports/PCA/v2.3.6/Fannie Mae PCA.xsd`,
   esaschema:`file:///C:/Users/e4ujys/Fannie%20Mae/OneDrive%20-%20Fannie%20Mae/3rd%20Party%20Reports/ESA/v2.3.6/Fannie Mae ESA.xsd`,
   sraschema:`file:///C:/Users/e4ujys/Fannie%20Mae/OneDrive%20-%20Fannie%20Mae/3rd%20Party%20Reports/SRA/v2.3.6/Fannie Mae SRA.xsd`,
   zonschema:`file:///C:/Users/e4ujys/Fannie%20Mae/OneDrive%20-%20Fannie%20Mae/3rd%20Party%20Reports/ZON/v2.3.6/Fannie Mae ZON.xsd`,
   acceptType: 'png,PNG,jpg,JPG,jpeg,JPEG,xlsx,XLSX,csv,CSV,txt,TXT,docx,DOCX,doc,DOC,pdf,PDF,ppt,PPT,pptx,PPTX,kml,KML,dwg,DWG',
   spellCheck:`https://svc.webspellchecker.net/api?`,
   spellServideId:`2zhLQV1aAvOyLT0`,
   specialChar:"\`!@#$%^&*()+=\[\]{}:\\|<>\/?~",//`\`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`
   googlemapkey:`AIzaSyDPlwbqF6GcXeR6eSAHdTxbnAEcmTFZxv4`,
   ckTrackChangeKey:'T1JTUTl1bFBLWmdEVEtTNzNCRVdUOWZlcGNxRGQ1c3JIdStsbGVRbGZFdytJMEl1WkN5UGt4Z1dwZlo1d1V3bmFZZ0ZiTTh5M3Q2b2JsOD0tTWpBeU5URXhNekE9', //'c0hBLytyWGZuSmlKMnJaV0VkVUpZUk4xTGlQUW1IVUZvZGYvZUNIVTNqWkpEKzhBM2dGY2Erc3ZWMVYwSzBKbGlXVGh3Rm1EVlE9PS1NakF5TlRFeE16QT0=',
   ckProxy: 'https://ai.erisinfo.com/ckeditorProxy/generate',
   autoSave:`Y`,
   autoSaveInterval: 60000,
   spellcheckmaxbyte:30000,
   //Client Microsoft SSO
   microsoftsso:[
    {
      clientid:"stantec",
      Login: `https://sso.scriva.com/scriva/saml/login`,
      Authorize: `https://sso.scriva.com/scriva/saml/authorize`,
    }, 
    //for rincon sso integration
    {
      clientid:"rincon",
      Login: `https://sso.scriva.com/scrivarincon/saml/login`,
      Authorize: `https://sso.scriva.com/scrivarincon/saml/authorize`,
    },
    //for stantec canada sso integration
    { 
      clientid:"stanteccanada",
      Login: `https://sso.scriva.com/scriva-stantec-canada/saml/login`,
      Authorize: `https://sso.scriva.com/scriva-stantec-canada/saml/authorize`,
    }
  ],

  generateMobilKML:`https://erisservice8.erisinfo.com/ErisExt/repwservice_prod21/RepService.svc/GenerateMobileKML`,*/
   
    //test:
   /*generateExcel: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/GenerateExcel`,
    generatePdf: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/v2_ConvertToPdf`,
    pdfToWord: `https://erisservice9.erisinfo.com/ErisExt/reppdftoword-test/PDFtoWord`,
    generateCloserXML: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/GenerateCloserXML`,
    htmlToPdf: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/HtmlToPdf`,
    universalCall: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/CallOra`,
    ssoLogin: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/SSOLogin`,
    uploadFile2: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/V2_UploadFile`,
    mergePdf2: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RWPDFSrv.svc/MergePDF_v2`,
    saveHFURL: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/SaveHeaderFooterData`,
    toExcelURL: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/GenerateTableExcel`,
    getHFSample: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/GetFooterHeaderTemplates`,
    addStamp: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RWPDFSrv.svc/AddStamp`,
    rotateImage: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/RotateImage`,
    generateXML: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/GenerateXML`,
    generateJson: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/GenerateJson`,
    generatePortfolioZip: `https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/GeneratePortfolioZip`,
    pcaschema:`file:///C:/Users/e4ujys/Fannie%20Mae/OneDrive%20-%20Fannie%20Mae/3rd%20Party%20Reports/PCA/v2.3.6/Fannie Mae PCA.xsd`,
    esaschema:`file:///C:/Users/e4ujys/Fannie%20Mae/OneDrive%20-%20Fannie%20Mae/3rd%20Party%20Reports/ESA/v2.3.6/Fannie Mae ESA.xsd`,
    sraschema:`file:///C:/Users/e4ujys/Fannie%20Mae/OneDrive%20-%20Fannie%20Mae/3rd%20Party%20Reports/SRA/v2.3.6/Fannie Mae SRA.xsd`,
    zonschema:`file:///C:/Users/e4ujys/Fannie%20Mae/OneDrive%20-%20Fannie%20Mae/3rd%20Party%20Reports/ZON/v2.3.6/Fannie Mae ZON.xsd`,
    acceptType: 'png,PNG,jpg,JPG,jpeg,JPEG,xlsx,XLSX,csv,CSV,txt,TXT,docx,DOCX,doc,DOC,pdf,PDF,ppt,PPT,pptx,PPTX,kml,KML,dwg,DWG',
    spellCheck:`https://svc.webspellchecker.net/api?`,
    spellServideId:`2zhLQV1aAvOyLT0`,
    specialChar:"\`!@#$%^&*()+=\[\]{}:\\|<>\/?~",//`\`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`
    autoSave: `Y`,
    ckTrackChangeKey:'VFJ0RkxJZERJelNVUmtROUh6dFpvS0hyUUVnZ282ZWwrZU9sc253RXNwN01PUEp6eWY1S3pRVDM5REl1T1hFWTBtWjVyZkJrSlhjb2tOND0tTWpBeU5URXhNekE9',//'N2pmS0NXQkZmWWRwVHdsL05tdjE3blBmOURIeUo3dmdQUnVwdWhhRGkvTHFieEs0aHkxUnd0K3IxNEd0TFlMT1FDMktESlh6Rnc9PS1NakF5TlRFeE16QT0=',
    ckProxy: 'https://ai.erisinfo.com/ckeditorProxy/generatet',
    googlemapkey:`AIzaSyDPlwbqF6GcXeR6eSAHdTxbnAEcmTFZxv4`,
     //for stantec sso integration
    samlLogin: `https://erisservice9.erisinfo.com/ErisExt/sso_service_dev/saml/login`,
    samlAuthorize: `https://erisservice9.erisinfo.com/ErisExt/sso_service_dev/saml/authorize`,
    //for stantec canada sso integration
    stanteccanadasamlLogin: `https://erisservice9.erisinfo.com/ErisExt/sso-stanteccanada-service-test/saml/login`,
    stanteccanadasamlAuthorize: `https://erisservice9.erisinfo.com/ErisExt/sso-stanteccanada-service-test/saml/authorize`,
    //for rincon sso integration
    rinconsamlLogin: `https://erisservice9.erisinfo.com/ErisExt/sso-rincon_service_test/saml/login`,
    rinconsamlAuthorize: `https://erisservice9.erisinfo.com/ErisExt/sso-rincon_service_test/saml/authorize`,
    generateMobilKML:`https://erisservice9.erisinfo.com/ErisExt/repwservice_test21/RepService.svc/GenerateMobileKML`,
    autoSaveInterval: 60000,
    spellcheckmaxbyte:30000,*/
    

    // dev 12 c
    generateExcel: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/GenerateExcel`,
    generatePdf: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/v2_ConvertToPdf`,
    pdfToWord: `https://erisservice9.erisinfo.com/ErisExt/reppdftoword-test/PDFtoWord`,
    generateCloserXML: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/GenerateCloserXML`,
    htmlToPdf: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/HtmlToPdf`,
    universalCall: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/CallOra`,
    ssoLogin: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/SSOLogin`,
    uploadFile2: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/V2_UploadFile`,
    mergePdf2: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RWPDFSrv.svc/MergePDF_v2`,
    saveHFURL: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/SaveHeaderFooterData`,
    toExcelURL: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/GenerateTableExcel`,
    getHFSample: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/GetFooterHeaderTemplates`,
    addStamp: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RWPDFSrv.svc/AddStamp`,
    rotateImage: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/RotateImage`,
    generateXML: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/GenerateXML`,
    generateJson: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/GenerateJson`,
    generatePortfolioZip: `https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/GeneratePortfolioZip`,
    pcaschema:`file:///C:/Users/e4ujys/Fannie%20Mae/OneDrive%20-%20Fannie%20Mae/3rd%20Party%20Reports/PCA/v2.3.6/Fannie Mae PCA.xsd`,
    esaschema:`file:///C:/Users/e4ujys/Fannie%20Mae/OneDrive%20-%20Fannie%20Mae/3rd%20Party%20Reports/ESA/v2.3.6/Fannie Mae ESA.xsd`,
    sraschema:`file:///C:/Users/e4ujys/Fannie%20Mae/OneDrive%20-%20Fannie%20Mae/3rd%20Party%20Reports/SRA/v2.3.6/Fannie Mae SRA.xsd`,
    zonschema:`file:///C:/Users/e4ujys/Fannie%20Mae/OneDrive%20-%20Fannie%20Mae/3rd%20Party%20Reports/ZON/v2.3.6/Fannie Mae ZON.xsd`,
    //getbannerMsg:`https://erisservice9.erisinfo.com/ErisExt/notice-service-test/MessageChange.svc/GetScrivaMess`,
    //updatebannerMsg:`https://erisservice9.erisinfo.com/ErisExt/notice-service-test/MessageChange.svc/UpdateScrivaMess`,
    spellCheck:`https://svc.webspellchecker.net/api?`,
    spellServideId:`2zhLQV1aAvOyLT0`,
    specialChar:"\`!@#$%^&*()+=\[\]{}:\\|<>\/?~",//`\`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`
    autoSave: `Y`,
    googlemapkey:`AIzaSyDPlwbqF6GcXeR6eSAHdTxbnAEcmTFZxv4`,
    acceptType: 'png,PNG,jpg,JPG,jpeg,JPEG,xlsx,XLSX,csv,CSV,txt,TXT,docx,DOCX,doc,DOC,pdf,PDF,ppt,PPT,pptx,PPTX,kml,KML,dwg,DWG',
    ckTrackChangeKey:'VFJ0RkxJZERJelNVUmtROUh6dFpvS0hyUUVnZ282ZWwrZU9sc253RXNwN01PUEp6eWY1S3pRVDM5REl1T1hFWTBtWjVyZkJrSlhjb2tOND0tTWpBeU5URXhNekE9', //'N2pmS0NXQkZmWWRwVHdsL05tdjE3blBmOURIeUo3dmdQUnVwdWhhRGkvTHFieEs0aHkxUnd0K3IxNEd0TFlMT1FDMktESlh6Rnc9PS1NakF5TlRFeE16QT0=',//'UGdtYnBNUmE4VTFLUUVNa0RSS0dQMmtmeFlLa0lPQzhDd1R4blozRHFEV1plSjNnQ1ZGN2syWGhlY0hQWTBHenI4QVo4QWtWekE9PS1NakF5TlRBeE1EWT0',
    ckProxy: 'https://ai.erisinfo.com/ckeditorProxy/generated',
    blankSignature:'https://erisservice8.erisinfo.com/ExreportW/sig-template/signature%20type%20-%20blank.png',
    autoSaveInterval: 60000,
    spellcheckmaxbyte:30000,

    microsoftsso:[
      {
        clientid:"stantec",
        Login: `https://erisservice9.erisinfo.com/ErisExt/sso_service_dev/saml/login`,
        Authorize: `https://erisservice9.erisinfo.com/ErisExt/sso_service_dev/saml/authorize`,
      }, 
      //for rincon sso integration
      {
        clientid:"rincon",
        Login: `https://erisservice9.erisinfo.com/ErisExt/sso-rincon_service_dev/saml/login`,
        Authorize: `https://erisservice9.erisinfo.com/ErisExt/sso-rincon_service_dev/saml/authorize`,
      },
      //for stantec canada sso integration
      { 
        clientid:"stanteccanada",
        Login: `https://erisservice9.erisinfo.com/ErisExt/sso-stanteccanada-service-dev/saml/login`,
        Authorize: `https://erisservice9.erisinfo.com/ErisExt/sso-stanteccanada-service-dev/saml/authorize`,
      }
    ],
    generateMobilKML:`https://erisservice9.erisinfo.com/ErisExt/repwservice_dev21/RepService.svc/GenerateMobileKML`,
  
  },
  file_host: `http://localhost/M00/`,
  mapTools_host: `https://devmaprw.erisinfo.com/`,
  support_URL: `http://dev.erisinfo.com/`,
  order_URL: `https://testorder.erisinfo.com/home`,
  //local dev
   auth0: {
     domain: 'erisinfo.us.auth0.com',
     clientId: '5CYNIbXT1JFWlMM9XiLthNbAGQYp66Wj',
     audience: 'https://scriva.erisinfo.com/api/v1/',
     redirect_uri: 'http://localhost:4200/'
   }

  //deployment dev
 /* auth0: {
    domain: 'erisinfo.us.auth0.com',
    clientId: '5CYNIbXT1JFWlMM9XiLthNbAGQYp66Wj',
    audience: 'https://scriva.erisinfo.com/api/v1/',
    redirect_uri: 'https://devrw.erisinfo.com/'
  }*/
};  

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
